import { API_BASE, axiosApi } from "../config"
import { GeneralReturnInterface } from "../types"

export interface FlowCellRun {
    id: number
    ts: string
    pores: number | null
    duration: number | null
    nreads: number | null
    nSamples: number | null
}

export interface FlowCell {
    id: number
    name: string
    poresStartedWith: number
    poresLeft: number | null
    startToUse: string | null
    diedAt: string | null
    washed: boolean
    notes: string
    ts: string
    lastSave: string
    runs?: FlowCellRun[]
}

export interface GetFlowCellsReturnInterface {
    code: number
    flowcells?: FlowCell[]
    message?: string
}

export interface FlowCellReturnInterface {
    code: number
    flowcell?: FlowCell
    message?: string
}

export async function getFlowCells(): Promise<GetFlowCellsReturnInterface> {
    return (await axiosApi.post(`${API_BASE}/getFlowCells`, {})).data
}

export async function createFlowCell(body: {
    name: string
    poresStartedWith?: number
    poresLeft?: number | null
    startToUse?: string | null
    diedAt?: string | null
    notes?: string
}): Promise<FlowCellReturnInterface> {
    return (await axiosApi.post(`${API_BASE}/createFlowCell`, body)).data
}

export async function updateFlowCell(body: {
    flowCellId: number
    name?: string
    poresStartedWith?: number
    poresLeft?: number | null
    startToUse?: string | null
    diedAt?: string | null
    notes?: string
}): Promise<FlowCellReturnInterface> {
    return (await axiosApi.post(`${API_BASE}/updateFlowCell`, body)).data
}

export async function deleteFlowCell(body: {
    flowCellId: number
}): Promise<GeneralReturnInterface> {
    return (await axiosApi.post(`${API_BASE}/deleteFlowCell`, body)).data
}
